import React from "react";

const ContractorPerformanceIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <circle
        cx="7"
        cy="5"
        r="3"
        stroke="currentColor"
        strokeWidth="1.2"
      ></circle>
      <path
        d="M2 13c0-2.8 2.2-5 5-5s5 2.2 5 5"
        stroke="currentColor"
        strokeWidth="1.2"
        fill="none"
      ></path>
    </svg>
  );
};

export default ContractorPerformanceIcon;
